// Componente principal do conteúdo do Dashboard
import React from "react";
import StatsSection from "./StatsSection";
import PlaguesSection from "./PlaguesSection";
import FiltersSection from "./FiltersSection";
import CardsSection from "./CardsSection";
import style from "../body-dashboard.module.css";

/**
 * Componente DashboardContent - Conteúdo principal do Dashboard
 * @param {Object} props - Propriedades do componente
 */
const DashboardContent = ({
  hectar,
  alto,
  medio,
  baixo,
  plagues,
  municipality,
  showCards,
  enablePlague,
  plagueSelected,
  plots,
  onViewCards,
  onChangeMunicipio,
  onChangePlague
}) => {
  return (
    <div className={style["body-home"]}>
      {/* Seção de estatísticas principais */}
      <StatsSection
        hectar={hectar}
        alto={alto}
        medio={medio}
        baixo={baixo}
      />

      {/* Seção de pragas */}
      {plagues && plagues.length > 0 && (
        <PlaguesSection plagues={plagues} />
      )}

      {/* Seção de filtros */}
      {municipality && municipality.length > 0 && (
        <FiltersSection
          municipality={municipality}
          plagues={plagues}
          showCards={showCards}
          enablePlague={enablePlague}
          plagueSelected={plagueSelected}
          plots={plots}
          onViewCards={onViewCards}
          onChangeMunicipio={onChangeMunicipio}
          onChangePlague={onChangePlague}
        />
      )}

      {/* Seção de cards */}
      {showCards && (
        <CardsSection
          plots={plots}
          plagueSelected={plagueSelected}
        />
      )}

      {/* Área em branco quando não há dados */}
      {(!municipality || municipality.length === 0) && (
        <div className={style["cards"]} style={{ flex: 1, minHeight: "600px" }} />
      )}
    </div>
  );
};

export default DashboardContent;

